import { useCallback, useEffect } from 'react';

const useCopyPrevention = (): void => {
  const handleCopy = useCallback((event: ClipboardEvent) => {
    event.preventDefault(); // 복사 이벤트를 막음
    // 복사를 막기 위한 추가적인 로직을 작성할 수 있음
  }, []);

  // 복사 이벤트를 차단하는 이벤트 핸들러 등록
  useEffect(() => {
    document.addEventListener('copy', handleCopy);
    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, [handleCopy]);
};

export default useCopyPrevention;
